import * as React from 'react';

export const BoxedText: React.FC<{
  id?: string;
  className?: string;
  x: number;
  y: number;
  paddingX?: number;
  paddingY?: number;
  angle?: number;
  maxHeight?: number;
  minHeight?: number;
  minWidth?: number;
  borderRadius?: number;
  textColor?: string;
  bgColor?: string;
  textAnchor?: string;
  alignmentBaseline?: string;
  children?: React.ReactNode;
}> = (props) => {
  const [bounds, setBounds] = React.useState({ x: 0, y: 0, w: 0, h: 0 });

  const rot = props.angle ? `rotate(${props.angle} ${props.x} ${props.y})` : undefined;
  const paddingX = props.paddingX ?? 3;
  const paddingY = props.paddingY ?? 0;

  const textRef = React.useCallback(
    (node: SVGTextElement | null) => {
      if (!node) return;

      const bounds = node.getBoundingClientRect();
      const height = Math.min(
        props.maxHeight ?? 2000,
        Math.max(bounds.height, (props.minHeight ?? 0) - paddingY * 2)
      );
      const width = Math.max(bounds.width, (props.minWidth ?? 0) - paddingX * 2);

      let x = props.x;
      switch (props.textAnchor) {
        case 'middle':
          x = props.x - width / 2;
          break;
        case 'end':
          x = props.x - width;
          break;
        case 'start':
          x = props.x;
          break;
      }

      setBounds({
        x,
        y: props.y - height / 2,
        w: width,
        h: height,
      });
    },

    // Must include props.childern in dep array as changes in that change bounds
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.minHeight, props.textAnchor, props.x, props.y, props.children]
  );

  return (
    <g className={props.className} transform={rot}>
      <rect
        x={bounds.x - paddingX}
        y={bounds.y - paddingY}
        width={bounds.w + paddingX * 2}
        height={bounds.h + paddingY * 2}
        fill={props.bgColor}
        rx={props.borderRadius ?? 2}
        ry={props.borderRadius ?? 2}
      />
      <text
        id={props.id}
        ref={textRef}
        x={props.x}
        y={props.y}
        textAnchor={props.textAnchor}
        alignmentBaseline={props.alignmentBaseline as any}
        fill={props.textColor}
      >
        {props.children}
      </text>
    </g>
  );
};
